import { render, staticRenderFns } from "./TimeCounter.vue?vue&type=template&id=cd238df6&"
import script from "./TimeCounter.vue?vue&type=script&lang=ts&"
export * from "./TimeCounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports